
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2 4.052C2 2.919 2.919 2 4.052 2h11.896C17.081 2 18 2.919 18 4.052v11.896A2.052 2.052 0 0115.948 18H4.052A2.052 2.052 0 012 15.948V4.052zm11.631 3.302l-5.5-3.251C7.684 3.839 7 4.095 7 4.748v6.501a.75.75 0 001.131.646l5.5-3.25a.75.75 0 000-1.29zM7 14.556A.556.556 0 006.444 14H4.556a.556.556 0 00-.556.556v.888c0 .307.249.556.556.556h1.888A.556.556 0 007 15.444v-.888zM11.444 14c.307 0 .556.249.556.556v.888a.556.556 0 01-.556.556H8.556A.556.556 0 018 15.444v-.888c0-.307.249-.556.556-.556h2.888zm4.556.556a.556.556 0 00-.556-.556h-1.888a.556.556 0 00-.556.556v.888c0 .307.249.556.556.556h1.888a.556.556 0 00.556-.556v-.888z","fill":"#999"}})])
          )
        }
      }
    